import { dropdownHandler } from './dropdown';
import { inputHandler } from './input';
import { queryBuilder } from './utils';

const fetchItems = (body, list) => {
  const faq = document.getElementById('faq');
  const pageKey = faq.getAttribute('data-page-key');
  const apiUrl = faq.getAttribute('data-api-url');

  const params = new URLSearchParams({
    pageKey: pageKey,
    searchTerm: body['faq-search-input'],
    category: body.category,
  });

  fetch(apiUrl + '?' + params.toString(), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.text())
    .then((htmlContent) => {
      list.innerHTML = htmlContent;
    })
    .catch((error) => {
      console.error(error);
    });
};

const onFilter = (body, list) => {
  fetchItems(body, list);
  queryBuilder(body);
};

const onFAQLoad = () => {
  const faq = document.getElementById('faq');

  if (!faq) return;

  const accordion = faq.querySelector('[data-accordion]');
  const dropdown = faq.querySelector('[data-dropdown]');
  const input = faq.querySelector('[data-input-field]');

  const body = {};

  dropdownHandler(dropdown, (value) => {
    body.category = value;
    if (Object.keys(body).length === 2) onFilter(body, accordion);
  });

  inputHandler(input, (value) => {
    body['faq-search-input'] = value;
    if (Object.keys(body).length === 2) onFilter(body, accordion);
  });
};

export default onFAQLoad;
